import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslationsType, useTranslator } from '@Localization';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Feedback } from '../../../../../../../../__legacy__/components/Feedback';
import { S_Dropzone } from '../../../../../../../../design/dropzone/S_Dropzone';
import { S_ConfirmationModal } from '../../../../../../../../design/modals/confirmationModal/S_ConfirmationModal';
import { RowLayout } from '../../../../../../../common/layouts/rowLayout/RowLayout';

interface Props {
  canProceed: boolean;
  fileValidationError: string | undefined;
  show: boolean;
  onHide: () => void;
  onSubmit: () => Promise<void>;
  onFileDropped: (acceptedOrRejected: File[]) => Promise<void>;
  fileName?: string;
}

type ValidationKey = keyof TranslationsType['new']['projects']['details']['import_annotations']['steps']['select_file']['errors'];

export const SelectFileStepModal = observer((props: Props): ReactElement => {
  const { t } = useTranslator();

  const { canProceed, fileName, fileValidationError, show, onHide, onSubmit, onFileDropped } = props;
  return (
    <S_ConfirmationModal
      cancelText={t('new.projects.details.import_annotations.cancel')}
      headerText={`${t('new.projects.details.import_annotations.header')} - ${t('new.projects.details.import_annotations.steps.select_file.header')}`}
      submitText={t('new.projects.details.import_annotations.next')}
      onCancel={onHide}
      toggle={onHide}
      onSubmit={onSubmit}
      isOpen={show}
      disableSubmitButton={!canProceed}
    >
      <div>
        <p>
          {fileName ? (
            <span>
              {t('selected_file')}: <b>{fileName}</b>
            </span>
          ) : (
            <strong>{t('please_select_your_file')}</strong>
          )}
        </p>
        <p>
          {t('our_json_format_documentation_can_be_found')}
          <a
            href='https://api.acdl.zebra.com/export-json-format.html'
            target='blank'
          >
            {` ${t('here')}`}
          </a>
          .
        </p>
        <p>{t('max_file_size')}</p>
        <S_Dropzone
          multiple={false}
          onDrop={(files) => {
            void onFileDropped(files);
          }}
          className={classNames({
            'is-invalid': fileValidationError !== undefined,
          })}
        >
          <RowLayout
            size='sm'
            className='s-dropzone-content'
          >
            <FontAwesomeIcon icon={faUpload} />
            {t('drop_your_json_file_here_or_select_it_manually')}
          </RowLayout>
        </S_Dropzone>
        {fileValidationError && (
          <Feedback>{t(`new.projects.details.import_annotations.steps.select_file.errors.${fileValidationError as ValidationKey}`)}</Feedback>
        )}
      </div>
    </S_ConfirmationModal>
  );
});
